import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { assetUrl } from "@/lib/api";

const toDataUrl = async (id) => {
  if (!id) return null;
  try {
    const blob = await (await fetch(assetUrl(id))).blob();
    return await new Promise((res) => { const r = new FileReader(); r.onload = () => res(r.result); r.readAsDataURL(blob); });
  } catch { return null; }
};

const esc = (s) => String(s || "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

const pageHtml = (img, p, lang) => `
  <div style="height:340px;background:#f1ece2;display:flex;align-items:center;justify-content:center;overflow:hidden">
    ${img ? `<img src="${img}" style="width:100%;height:100%;object-fit:cover"/>` : ""}
  </div>
  <div style="padding:28px 36px">
    <div style="font-size:11px;letter-spacing:3px;color:#16a34a;text-transform:uppercase">${esc(lang)}</div>
    <p style="font-size:22px;line-height:1.5;margin:8px 0 14px;color:#111">${esc(p.native_text)}</p>
    ${p.phonetic ? `<p style="font-size:13px;font-style:italic;color:#6b7280;margin:0 0 14px">${esc(p.phonetic)}</p>` : ""}
    <p style="font-size:15px;line-height:1.6;color:#374151;border-top:1px solid #e5e7eb;padding-top:14px;margin:0">${esc(p.english_text)}</p>
    <div style="margin-top:22px;font-size:11px;color:#9ca3af">Page ${p.number}</div>
  </div>`;

const coverHtml = (book) => `
  <div style="height:100%;display:flex;flex-direction:column;justify-content:center;padding:60px;background:#1e1b2e;color:#fff">
    <div style="font-size:12px;letter-spacing:4px;color:#c084fc">INNOVATE FLOW STUDIO</div>
    <h1 style="font-size:40px;line-height:1.2;margin:18px 0">${esc(book.title)}</h1>
    <p style="font-size:16px;font-style:italic;color:#cbd5e1">${esc(book.moral)}</p>
  </div>`;

const renderToCanvas = async (html) => {
  const el = document.createElement("div");
  el.style.cssText = "position:fixed;left:-10000px;top:0;width:595px;height:842px;background:#fff;font-family:Georgia,'Noto Sans',serif";
  el.innerHTML = html;
  document.body.appendChild(el);
  try { return await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: "#ffffff" }); }
  finally { el.remove(); }
};

export const exportStorybookPdf = async (book, language) => {
  const pdf = new jsPDF({ unit: "pt", format: "a4" });
  const W = pdf.internal.pageSize.getWidth();
  const H = pdf.internal.pageSize.getHeight();
  pdf.addImage((await renderToCanvas(coverHtml(book))).toDataURL("image/jpeg", 0.9), "JPEG", 0, 0, W, H);
  const images = await Promise.all((book.pages || []).map((p) => toDataUrl(p.image_asset_id)));
  for (let i = 0; i < (book.pages || []).length; i++) {
    const canvas = await renderToCanvas(pageHtml(images[i], book.pages[i], language));
    pdf.addPage();
    pdf.addImage(canvas.toDataURL("image/jpeg", 0.9), "JPEG", 0, 0, W, H);
  }
  pdf.save(`${(book.title || "storybook").replace(/[\\/:*?"<>|]+/g, "").trim() || "storybook"}.pdf`);
};
